
/* injects from baggage-loader */

export const failDialg = [`Parece que você se <b>confundiu</b>! <br> <b>Observe</b> novamente os animais e <b>reescreva</b> os numerais apenas nos <b>quadrinhos destacados</b> com a cor vermelha.`]

export const feedbackFinishStage = [
  'Graças aos seus <b>esforços</b> nesta <br> missão, você ganhou a Medalha Oficial de <b>DEFENSOR DOS FILHOTES</b>!',
  'Você também será recompensado com <b>1/4 do distintivo</b> de <b>Guardião da Natureza</b>. para completá-lo, você precisa <b>concluir</b> as <b>outras</b> missões. Preparado?',
]

export const feedbackTexts = [
    'Você contou <b>direitinho</b>! Agora, <b>observe</b> novamente <b>os filhotes</b> para <b>responder</b> alguns <b>desafios</b>.'
];

export const feedbackTextsChallenge = [
    'Você respondeu <b>certinho</b>! Agora os <b>filhotes</b> estão prontos para <b>seguir viagem</b> com suas famílias.',
    'Só preciso que você <b>me ajude</b> com esse <b>próximo desafio</b>. Vamos lá?'
];


// WEBPACK FOOTER //
// ./src/app/components/dialogs/quiz-peixeboi/quiz-peixeboi.const.js